import { DetailScrollWrapper } from './detailScrollArea.styled';

interface DetailScrollAreaProps {
  children: React.ReactNode;
  className?: string;
  testId?: string;
}

/**
 * Scroll host for a detail screen's card, so the whole card stays reachable when the task pane is
 * short or zoomed in. The card fills a pane taller than itself and scrolls when it is the taller
 * of the two, with the page padding staying equal on both sides either way.
 */
const DetailScrollArea = ({ children, className = '', testId }: DetailScrollAreaProps) => (
  <DetailScrollWrapper data-testid={testId} className={`scroll-page-gutter ${className}`.trimEnd()}>
    <div className="detail-scroll-content">{children}</div>
  </DetailScrollWrapper>
);

export default DetailScrollArea;
